import React from 'react';
import styles from "../css/Commentator.module.css";
import Button from "components/inputs/Button";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { accountActions } from "../../reducers/account";
import AccountForm from "../../components/form/AccountForm";
import AccountService from "../../service/apiConfig/AccountService";
import { accountValidation } from "../../service/validation/accountValidation";

const AccountModal = () => {
    const dispatch = useDispatch();
    const accountDetail = useSelector(state => state.accountData.accountDetail);
    const openDetail = useSelector(state => state.accountData.openDetail);
    const user = useSelector(state => state.commonData.user);
    const { id, role, username, name, password, passwordConfirm } = accountDetail;

    const handleCloseDetail = () => {
        dispatch(accountActions.setOpenDetail(false));
        dispatch(accountActions.setAccountDetail({}));
    }
    const onEdit = () => {
        let data = {
            role: { id: role },
            id: id,
            name: name,
            username: username,
            password: password ? password : null,
            passwordConfirm: passwordConfirm ? passwordConfirm : null,
        };
        AccountService.create(data)
            .then(response => {
                let localData = {
                    "username": username,
                    "name": name,
                    "role": {
                        "category" : role === 1 || role === 2 ? "peopulley" : role === 3 || role === 4 ? "nmkpg" : null,
                        "name": role === 1 || role === 3 ? "admin" : role === 2 || role === 4 ? "owner" : null
                    }
                }
                if (user.username === username) {
                    localStorage.setItem('user', JSON.stringify(localData));
                }
                dispatch(accountActions.setOpenDetail(false));
                accountValidation(response);
            })
            .catch(err => console.log(err));
    }
    return (
        <>
        {openDetail &&
            <Dialog
                className={styles.commModal}
                open={openDetail}
                fullWidth={true}
                maxWidth={"sm"}
                onClose={(_, reason) => {
                    if (reason !== 'backdropClick') {
                        handleCloseDetail();
                    }
                }}>
                <DialogTitle>
                    <div className={"modalHeader"}>
                        <Button style={{ background: "#5a54a1" }} onClick={onEdit}>수정</Button>
                        <Button style={{ background: "#fff", border: "1px solid #bbb", color: "#222", padding: "0.5rem" }} onClick={handleCloseDetail}>나가기</Button>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <AccountForm />
                </DialogContent>
            </Dialog>
        }
        </>
    );
};

export default AccountModal;